import React from 'react';
import { Row, Col, Card, Dropdown, DropdownButton } from 'react-bootstrap-5';
import PropTypes from 'prop-types';

import { ProjectContactsPropTypes } from 'components/project/prop_types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faCircle, faUser, faBriefcase } from '@fortawesome/pro-solid-svg-icons';

export default class ContactPanelRow extends React.Component {
  static propTypes = {
    contact: ProjectContactsPropTypes,
    onCreateTask: PropTypes.func,
    onEditContact: PropTypes.func,
    onLogActivity: PropTypes.func,
    onRemoveContact: PropTypes.func
  };

  renderIcon(contact) {
    if (contact.type === 'company') {
      return (
        <span className='fa-stack'>
          <FontAwesomeIcon className="details-icon fa-stack-2x text-muted" icon={faCircle} />
          <FontAwesomeIcon className="fa-stack-1x fa-inverse" icon={faBriefcase} />
        </span>
      );
    }
    if (contact.initials.length > 0) {
      return (
        <div className='avatar avatar-lg'>
          <div>{contact.initials}</div>
        </div>
      );
    }
    return (
      <span className='fa-stack'>
        <FontAwesomeIcon className="details-icon fa-stack-2x text-muted" icon={faCircle} />
        <FontAwesomeIcon className="fa-stack-1x fa-inverse" icon={faUser} />
      </span>
    );
  }

  renderActions(contact) {
    const { onEditContact, onRemoveContact, onCreateTask, onLogActivity } = this.props;
    const anyActions = onEditContact || onRemoveContact || onCreateTask;

    if (!anyActions) return;

    return (
      <Col className="text-right" xs={2}>
        <DropdownButton
          id={`contacts-options-${contact.id}`}
          title={<FontAwesomeIcon icon={faEllipsisV} />}
          variant="ghost btn-icon"
        >
          {onCreateTask &&
            <Dropdown.Item
              eventKey="1"
              name={`create-contact-task-${contact.id}`}
              onClick={() => {
                onCreateTask({
                  defaultTaskAssociation: {
                    associatedModelId: contact.contactId,
                    associatedModelType: contact.contactType,
                    default: true,
                    name: contact.name
                  }
                });
              }}
            >
              New Task
            </Dropdown.Item>
          }
          {onLogActivity &&
            <Dropdown.Item
              eventKey="2"
              name={`log-contact-activity-${contact.id}`}
              onClick={() => {
                onLogActivity({
                  defaultTaskAssociation: {
                    associatedModelId: contact.contactId,
                    associatedModelType: contact.contactType,
                    default: true,
                    name: contact.name
                  }
                });
              }}
            >
              New Activity
            </Dropdown.Item>
          }
          {onEditContact &&
            <Dropdown.Item
              eventKey="3"
              name={`edit-contact-${contact.id}`}
              onClick={e => onEditContact(e, contact)}
            >
              Edit
            </Dropdown.Item>
          }
          {onRemoveContact &&
            <Dropdown.Item
              eventKey="4"
              name={`remove-contact-${contact.id}`}
              onClick={() => onRemoveContact(contact.id)}
            >
              Delete
            </Dropdown.Item>
          }
        </DropdownButton>
      </Col>
    );
  }

  render() {
    const { contact } = this.props;

    let link = (
      <span className="fw-semibold">
        { contact.name ? contact.name : contact.email }
      </span>
    );

    if (contact.link) {
      link = (
        <a href={contact.link} name='contactLink' >
          {link}
        </a>
      );
    }

    return (
      <Card.Body className='border-bottom' key={contact.id} name='contactRow'>
        <Row className='align-items-center'>
          <Col>
            <div className='text-muted mb-1'>{ contact.header }</div>
            <Row className='align-items-center'>
              <Col xs="auto">
                {this.renderIcon(contact)}
              </Col>
              <Col>
                { link }
                { contact.name &&
                  <div>{ contact.email }</div>
                }
                <div>{ contact.phone }</div>
                <div>{ contact.companyName }</div>
              </Col>
            </Row>
          </Col>
          <Col xs="auto">
            {this.renderActions(contact)}
          </Col>
        </Row>
      </Card.Body>
    );
  }
}
